var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { column: "", role: "region", "aria-label": "Guides content" } },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/guide-cover.png",
          height: "350",
          role: "img",
          "aria-label": "Guides section banner",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                column: "",
                "pb-2": "",
                role: "region",
                "aria-label": "Guides layout",
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c("search", {
                    attrs: {
                      subject: "guides",
                      limit: _vm.limit,
                      "aria-label": "Search guides",
                    },
                    on: { onChangedText: _vm.onSearchChange },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "", "pb-2": "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg8: "",
                            "justify-center": "",
                            "text-center": "",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "guides-buttons-disenchantment",
                              attrs: {
                                color: "accent",
                                type: "button",
                                "aria-label": "Disenchantment button",
                              },
                              on: { click: _vm.goToDisenchantmentCollection },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.guides.buttons.disenchantment"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("posts", {
                    attrs: {
                      posts: _vm.posts,
                      title: _vm.$t("components.guides.title"),
                      "is-loading": _vm.isLoading,
                      role: "region",
                      "aria-label": "Guides posts section",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }